module.exports = __webpack_public_path__ + "img/reward_intro.b9958d27.png";